import React, { Fragment, useState} from 'react';
import { useDebouncedCallback } from "use-debounce";

import { getSearchResults } from "../../../../api/search";
import DropdownWithSearch from "../../../SharedComponents/Forms/DropdownWithSearch";
import SvgIcon from "../../../SharedComponents/Icons";

import './index.sass';


const SearchAreaFilter = ({ generateBreadcrumbs,
                            regionsOptions,
                            setBreadcrumbs,
                            setCoords,
                            setPage,
                            setSelectedDistrict,
                            setSelectedRegion }) => {

  const [inputValue, setInputValue] = useState('');
  const [missingSearchResults, setMissingSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState({ districts: [], places: [], regions: [] });


  const checkAvailableSearchResults = (data) =>
    !!(data && (data.districts.length || data.regions.length || data.places.length));


  const searchResultsPresent = React.useMemo(
    () => {
      return checkAvailableSearchResults(searchResults);
    },
    [searchResults],
  );


  const handleSelect = (data) => {
    const breadcrumbs = generateBreadcrumbs(data);
    const selectedRegionSlug = data.slug;

    setSelectedDistrict(null);
    setSelectedRegion(selectedRegionSlug);
    setPage(1);
    setCoords({});
    setBreadcrumbs(breadcrumbs);
    pushState(`/${data.slug}`, { selectedRegionSlug }, breadcrumbs);
  };


  const pushState = (locationUrl, locationData, breadcrumbs) => {
    const state = { ...locationData, breadcrumbs };
    const urlSearchParams = new URLSearchParams(window.location.search);

    urlSearchParams.has('page') && urlSearchParams.delete('page');

    const searchParamsString = urlSearchParams.toString();
    const url = `/leje${locationUrl}${searchParamsString ? `?${searchParamsString}` : ''}`;
    const sameUrl = window.location.pathname + window.location.search === url;

    setInputValue('');
    setSearchResults({ districts: [], places: [], regions: [] });
    setMissingSearchResults(false)
    !sameUrl && history.pushState(state, '', url);
  };


  const handleSearch = (query) => {
    setInputValue(query);
    handleDeferredQuery();
  };


  const handleDeferredQuery = useDebouncedCallback(() => {
    handleSearchResults(inputValue);
  }, 200);


  const handleSearchResults = (query) => {
    getSearchResults(query).then((results) => {
      const noResults = !checkAvailableSearchResults(results) && !!query;

      setSearchResults(results);
      setMissingSearchResults(noResults);
    });
  };


  const searchResultsComponent = !!(missingSearchResults || searchResultsPresent) &&
    <div className="search-area__search-results">

      { searchResults &&
        <Fragment>
          { !!searchResults.places.length &&
            <div className="search-area__search-results-list">
              <div className="search-area__search-results-list-headline">
                Navn på stedet
              </div>
              { searchResults.places.map((place, index) =>
                <a className="search-area__search-results-list-item dropdown__option no-border"
                   href={place.url}
                   key={'place' + place.url + index}
                   target="_blank">
                  <div className="search-area__search-results-item-label">
                    { place.name }
                  </div>
                  <SvgIcon name="arrow_right_alt" size={24} />
                </a>
              )}
            </div>
          }

          { !!searchResults.districts.length &&
            <div className="search-area__search-results-list regions">
              <div className="search-area__search-results-list-headline">
                Områder
              </div>
              { searchResults.districts.map((district, index) =>
                <a className="search-area__search-results-list-item dropdown__option no-border"
                   href={district.url}
                   key={'district' + district.url + index}>
                  <div className="search-area__search-results-item-label district">
                    { district.name }
                  </div>
                </a>
              )}
            </div>
          }

          { !!searchResults.regions.length &&
            <div className="search-area__search-results-list regions">
              <div className="search-area__search-results-list-headline">
                Landsdele
              </div>
              { searchResults.regions.map((region, index) =>
                <a className="search-area__search-results-list-item dropdown__option no-border"
                   href={region.url}
                   key={'region' + region.url + index}>
                  <div className="search-area__search-results-item-label region">
                    { region.name }
                  </div>
                </a>
              )}
            </div>
          }
        </Fragment>
      }

      { missingSearchResults &&
        <div className="dropdown__no-results">
          Din søgning giver desværre ingen resultater. Prøv eventuelt at søge på et postnummer eller en landsdel.
        </div>
      }
    </div>;


  return (
    <DropdownWithSearch
      handleSelect={handleSelect}
      handleSearch={handleSearch}
      inputValue={inputValue}
      options={regionsOptions}
      placeholder={'Postnummer eller By'}
      searchIcon={<SvgIcon name="map_pin" size={16} />}
      searchResultsComponent={searchResultsComponent}
      showDefaultOptions={missingSearchResults || !searchResultsPresent}
    />
  )
};

export default SearchAreaFilter;
